
<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="pipelinegradeForm">
    <div class="">
      <h3 class="form_name">Pipeline Grade</h3>


        <div class="input">
          <label for="">Pipeline Grade</label>
          <input type="text" class="default_input reference-form" formControlName="PipelineGradeName" />
        </div>


      <div class="btn_holder">
        <button class="default_primary-button" *ngIf="selectedIndex === null" (click)="addNew(pipelinegradeForm.value)">Add</button>
        <button class="default_primary-button" *ngIf="selectedIndex !== null" (click)="addNew(pipelinegradeForm.value)">Update</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

      </div>

    </div>
  </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search"
        placeholder="Search for Pipelinegrade"
        [formControl]="control"
        [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="(pipelinegrades | filterReference: control.value) as result"
            >
              <app-option
                (click)="selectPipelinegrade(option.id)"
                *ngFor="let option of result"
                [value]="option.PipelineGradeName"
              >
                {{ option.PipelineGradeName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">Pipeline Grade</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" >
      <div class="the_body"
      *ngFor="let pipelinegrade of pipelinegradeFormArray.get('Pipelinegrades')['controls']; index as i"
      (click)="onEdit(i, pipelinegrade.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{pipelinegrade.value.PipelineGradeName}}</span>
        <span class="content" (click)="$event.stopImmediatePropagation()">
          <button
          class="delete_icon trash"

          (click)="deletePipelinegrade(i, pipelinegrade.value)">
          <em class="ti-trash"> </em> </button>
        </span>

      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(pipelinegradeFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
